<template>
  <div class="jo-keyword" id="keyword">
    <div v-for="item in keyword">
    <div v-if="item.lang == lang || layout == 'rc' && isBilingual">
      <h2 v-if="item.lang == 'zh'">关键词</h2>
      <h2 v-else>Keywords</h2>
      <p>
          <span :ref="'keyword' + item.lang">
            <a v-if="showLink" v-for="(item2,index) in item.data" target="_blank" :id="'kwd' + item.lang + index" :style="{'color' : ARTICLE.theme}"
                                 :href="'https://xueshu.baidu.com/s?wd='+getKeyText(item2,index,item.lang)" v-bind:key="index">
              <component :is="'jo' + item3.name" v-for="item3 in item2" v-bind:key="item3.index"
                       v-bind:data="item3.data"></component>{{index != (item.data.length - 1) ? ';' : ''}}
            </a>
            <span v-if="!showLink" v-for="(item2,index) in item.data" :id="'kwd' + item.lang + index" :style="{'color' : ARTICLE.theme}" v-bind:key="index">
              <component :is="'jo' + item3.name" v-for="item3 in item2" v-bind:key="item3.index"
                       v-bind:data="item3.data"></component>{{index != (item.data.length - 1) ? ';' : ''}}
            </span>
          </span>
        <translator v-if="showTrans && item.lang === 'en' && kwText != ''" :data="kwText"></translator>
      </p>
    </div>
    </div>
  </div>
</template>

<script>
  import joinlineformula from '../formula/inlineformula.vue'
  import translator from '../../../../commonComponents/translator.vue'
    export default {
      components: {
        joinlineformula,
        translator
      },
      data() {
        return {
          lang: this.ARTICLE.defaultlang,
          keyword: [],
          kwText: ''
        }
      },
      created() {
          this.keyword = this.ARTICLE.keyword
      },
      mounted() {
        if (this.showTrans){
          let _this = this;
          this.$nextTick(function () {
            _this.kwText = $(_this.$refs.keyworden).text()
          })
        }
      },
      activated() {
        this.$bus.on('currentLang', (lang) => {
          this.lang = lang;
        })
      },
      methods: {
        getKeyText(keyItem,index1,lang) {
          let keyText = "";
          keyItem.forEach((item, index) => {
            if (item.name == "inlineformula") {

              this.$nextTick(function () {
                let kwdDom = document.getElementById('kwd' + lang +index1);
                kwdDom.setAttribute('href','https://xueshu.baidu.com/s?wd='+kwdDom.innerText)
              })
            } else if(item.name === "text"){
              keyText += item.data;
            }
            else {
              keyText += this.getKeyText(item.data)
            }
          });
          return keyText;
        }
      }
    }
</script>
<style lang="scss" scoped>
    .jo-keyword {
      h2 {
        background: none;
        color: #333;
      }
      a{
        color:#00a2af;
      }
      a:hover{
        text-decoration: underline;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/maincontent/body/keyword/keyword.vue